import React from 'react'
import {
  type CrossClientQueryResultAnswer,
  type CrossClientQueryResultEvaluationType,
  CrossClientQueryResultEvaluationTypes,
  type CrossClientQueryResultMatch,
  CrossClientQueryResultMatches,
} from '../../../../models/CrossClient'

export interface CrossClientResultAnswerExplanationProps {
  answer: CrossClientQueryResultAnswer
  match: CrossClientQueryResultMatch
  evaluationType?: CrossClientQueryResultEvaluationType
}

export const CrossClientResultAnswerExplanation: React.FC<CrossClientResultAnswerExplanationProps> = ({ answer, match, evaluationType }) => {
  if (evaluationType === CrossClientQueryResultEvaluationTypes.AI) {
    return answer.explanation || null
  }
  if (answer.source) {
    return answer.explanation
  }
  if (match === CrossClientQueryResultMatches.NO_MATCH) {
    return <span className='zocks-text-gray-600'>Skipped. Client didn't meet another required condition.</span>
  }
  if (match === CrossClientQueryResultMatches.MATCH) {
    return <span className='zocks-text-gray-600'>Skipped. Client met another eligible condition.</span>
  }
  return answer.explanation || null
}
